import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
  Input,
  Button
} from "reactstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import Request from "../../../../helpers/request";
import axios from "axios";
import * as url from "../../../../helpers/url_helper";
import { convertProfileLocalDate } from "../../../../Utils/configController";
import ChipsList from "./ChipsDetail/ChipsList";
import BlasterList from "./BlasterList";
import LockList from "./LockList";
import CurtainList from "./CurtainList";
import ScheduleList from "./ScheduleList";
import DeviceList from "./DeviceList";
import { Images } from "../../../../constants/images";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import {
  selectedPremiseRooms,
  selectedPremiseRoomsList,
  selectedPremiseRoomsNew,
  setSelectedProfileDetails,
} from "../../../../store/slices/APIResponseSlice";
import { useSelector } from "react-redux";
import UserAction from "./UserAction";
import SceneList from "./SceneList";
import DriverList from "./DriverList";
import SharedUsersList from "./SharedUsersList";
import AutomationList from "./AutomationList";
import { Tooltip } from "react-tooltip";
import UserSettingModal from "./UserSettingModal";
import GatewayList from "./GatewayList";
import Select from "react-select";
import AccountSummary from "./AccountSummary";
import PendingTicker, { PendingAction } from "./Common/PendingTicker";

const tabs = [
  { key: "chips", label: "Chips", component: ChipsList },
  { key: "blaster", label: "Blaster", component: BlasterList },
  { key: "lock", label: "Lock", component: LockList },
  { key: "curtain", label: "Curtain", component: CurtainList },
  // { key: "driver", label: "Driver", component: DriverList },
  { key: "gateway", label: "Gateway", component: GatewayList },
  { key: "scene", label: "Scene", component: SceneList },
  { key: "schedule", label: "Schedule", component: ScheduleList },
  { key: "Automation", label: "Automation", component: AutomationList },
  { key: "device", label: "Device", component: DeviceList },
  // { key: "logs", label: "Logs", component: UserAction },
];

// Options for the "Default Screen" select in the Edit Profile modal.
// Mirrors the tab keys used elsewhere in this page.
const DEFAULT_SCREEN_OPTIONS = [
  { label: "Scene", value: "scenes" },
  { label: "Quick Access", value: "quickAccess" },
  { label: "Devices", value: "devices" },
];

const MOBILE_GRID_OPTIONS = [3, 4];

// Same select styling used by SelectFilters.tsx, kept local so this file
// doesn't need to import a component built for filter rules.
const citySelectStyles: any = {
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    fontWeight: "normal",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#6c757d",
    fontWeight: "normal",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "#333",
    fontWeight: "normal",
  }),
  control: (provided: any) => ({
    ...provided,
    minHeight: 36,
    height: 32,
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: 32,
  }),
  option: (provided: any) => ({
    ...provided,
    fontSize: 12,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
  }),
};

// interface PendingAction {
//   type: string;
//   remainingPercentage: number;
//   message: string;
// }

// const PendingTicker: React.FC<{ actions: PendingAction[] }> = ({ actions }) => {
//   const trackRef = useRef<HTMLDivElement>(null);
//   const animRef = useRef<Animation | null>(null);

//   useEffect(() => {
//     const el = trackRef.current;
//     if (!el || !actions.length) return;

//     const totalChars = actions.reduce((n, a) => n + a.message.length + 12, 0);
//     const duration = Math.max(15, totalChars * 0.18) * 1000; // ms

//     animRef.current = el.animate(
//       [{ transform: "translateX(0)" }, { transform: "translateX(-50%)" }],
//       { duration, iterations: Infinity, easing: "linear" }
//     );

//     return () => animRef.current?.cancel();
//   }, [actions]);

//   if (!actions.length) return null;

//   const renderItems = (hidden = false) => (
//     <div
//       className="d-flex flex-shrink-0"
//       style={{ minWidth: "100vw" }}
//       aria-hidden={hidden}
//     >
//       {actions.map((a, i) => (
//         <span
//           key={`${a.type}-${i}`}
//           className="d-inline-flex align-items-center gap-2 px-4 text-nowrap small text-dark"
//           style={{ fontSize: 13 }}
//         >
//           <i className="bx bxs-circle text-danger" style={{ fontSize:6 }} />
//           {a.message}
//           <span className="badge rounded-pill bg-danger-subtle text-danger fw-semibold">
//             {a.remainingPercentage ? a.remainingPercentage : "0"}% left
//           </span>
//         </span>
//       ))}
//     </div>
//   );

//   return (
//     <div className="d-flex align-items-center overflow-hidden bg-white border rounded mb-2">
//       <div className="flex-shrink-0 bg-danger text-white fw-bold small px-3 py-2">
//         PENDING
//       </div>

//       <div
//         className="flex-grow-1 overflow-hidden"
//         onMouseEnter={() => animRef.current?.pause()}
//         onMouseLeave={() => animRef.current?.play()}
//       >
//         <div ref={trackRef} className="d-flex" style={{ width: "max-content" }}>
//           {renderItems()}
//           {renderItems(true)}
//         </div>
//       </div>
//     </div>
//   );
// };

const ProfileList = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any[]>([]);
  const [deviceDetails, setDeviceDetails] = useState<any[]>([]);
  const [premiseList, setPremiseList] = useState<any[]>([]);
  const [selectedPremise, setSelectedPremise] = useState<any>("");
  const [isOpenProModal, setOpenProModal] = useState<boolean>(false);
  // const [selectedPremiseRooms, setSelectedPremiseRooms] = useState<any[]>([]);
  const [roomList, setRoomList] = useState<any[]>([]);
  const [sharedList, setsharedList] = useState<any[]>([]);
  const [parentList, setParentList] = useState<any[]>([]);
  const [isVacationMode, setIsVacationMode] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string | null>(null);
  const [mobileGrid, setMobileGrid] = useState<number>(0);
  const [tabGrid, settabGrid] = useState<number>(0);
  const [isSearchBar, setSearchBar] = useState<boolean>(false);
  const [noOfDeviceLimit, setNoOfDeviceLimit] = useState<number>(0);
  const activeTabFromStore = useSelector(
    (state: any) => state.APIResponse.activeTab
  );
 const [accountPendingActions, setAccountPendingActions] = useState<PendingAction[]>([]);
const [touchCodeActions, setTouchCodeActions] = useState<PendingAction[]>([]);

const pendingActions = useMemo(
  () => [...touchCodeActions, ...accountPendingActions],
  [touchCodeActions, accountPendingActions],
);
  useEffect(() => {
    if (activeTabFromStore && activeTabFromStore !== selectedTab) {
      setSelectedTab(activeTabFromStore);
    }
  }, [activeTabFromStore]);
  const [isEditModalOpen, setEditModalOpen] = useState<boolean>(false);


interface EditForm {
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  cityId: string;
  noOfDeviceLimit: string | number;
  defaultScreen: string;
  mobileGrid: number;
  isSearchBar: boolean;
  vacationMode: boolean;
}

const emptyEditForm: EditForm = {
  firstname: "",
  lastname: "",
  email: "",
  mobile: "",
  cityId: "",
  noOfDeviceLimit: "",
  defaultScreen: "",
  mobileGrid: 0,
  isSearchBar: false,
  vacationMode: false,
};

  const [editForm, setEditForm] = useState<EditForm>(emptyEditForm);
  const [originalForm, setOriginalForm] = useState<EditForm>(emptyEditForm);
  const [editLoading, setEditLoading] = useState<boolean>(false);
  const [staticOtps, setStaticOtps] = useState<any[]>([]);
  const [staticOtpLoading, setStaticOtpLoading] = useState(false);
  const [emailOtpValue, setEmailOtpValue] = useState("");
  const [mobileOtpValue, setMobileOtpValue] = useState("");
  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [selectedCityOption, setSelectedCityOption] = useState<any>(null);
 

  interface Streak {
    count: number;
    lastStreakDate: string;
  }

  const [streak, setStreak] = useState<Streak>({
    count: 0,
    lastStreakDate: "",
  });

  const handleTabChange = (tab: string) => {
    if (selectedTab !== tab) setSelectedTab(tab);
  };

  const citySearchApiCall = (e: any, setCityData: any) => {
    const value = !e ? "a" : e;
    Request.get(`${url.GET_SEARCH_CITY_URL}?keyword=${value}`)
      .then((res: any) => {
        var city: any[] = [];
        for (var i = 0; i < res.data?.data?.length; i++) {
          var ele = res.data.data[i];
          city.push({ label: ele.name, value: ele.id });
        }
        setCityData(city);
      })
      .catch((err: any) => {
        console.error("Error fetching data:", err);
      });
  };

  const changeProPremise = () => {
    setLoading(true);
    const reqObj = {
      premiseId: selectedPremise?.id,
      isPro: selectedPremise?.isPro ? false : true,
    };

    Request.post(url.CHANGE_PREMISE_PRO, reqObj)
      .then((res) => {
        getProfileListDetail();
        setLoading(false);
        toggleProModal();
        toast.success(res.data.msg);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const toggleEditModal = () => {
    if (isEditModalOpen) {
      setEditForm(originalForm);
    } else if (cityOptions.length === 0) {
      citySearchApiCall(null, setCityOptions);
  }
    setEditModalOpen(!isEditModalOpen);
  };

  // Generic handler for plain <Input> fields (text / number / checkbox).
  const handleEditChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDefaultScreenChange = (selected: any) => {
    setEditForm((prev) => ({ ...prev, defaultScreen: selected?.value || "" }));
  };

  const handleMobileGridChange = (value: number) => {
    setEditForm((prev) => ({ ...prev, mobileGrid: value }));
  };

  const handleUpdateProfile = () => {
    const changedFields: Record<string, any> = {};
    (Object.keys(editForm) as (keyof EditForm)[]).forEach((key) => {
      if (editForm[key] !== originalForm[key]) {
        changedFields[key] = editForm[key];
      }
    });

    if (Object.keys(changedFields).length === 0) {
      toggleEditModal();
      return;
    }

    if (changedFields.noOfDeviceLimit !== undefined) {
      changedFields.noOfDeviceLimit = Number(changedFields.noOfDeviceLimit);
    }
   
    setEditLoading(true);
    const reqObj = {
      userId: params.id,
      ...changedFields,
    };

    Request.put(url.UPDATE_USER_DETAILS, reqObj)
      .then((res) => {
        setEditLoading(false);
        toggleEditModal();
        toast.success(res.data.msg);
        getProfileListDetail();
      })
      .catch((err) => {
        setEditLoading(false);
        toast.error(err?.response?.data?.msg || "Failed to update profile");
      });
  };
const handleCityChange = (selected: any) => {
  setSelectedCityOption(selected);
  setEditForm((prev) => ({ ...prev, cityId: selected?.value || "" }));
};

  const handleAddStaticOtp = (type: "email" | "mobile") => {
    const value = (type === "email" ? emailOtpValue : mobileOtpValue).trim();
    const contactValue = editForm[type]?.trim();

    if (!contactValue) {
      toast.error(`Please enter a ${type}`);
      return;
    }
    if (!value) {
      toast.error("Please enter a static OTP");
      return;
    }
    if (staticOtps.some((item) => item?.[type] === contactValue)) {
      toast.error(`A static OTP already exists for this ${type}`);
      return;
    }

    setStaticOtpLoading(true);
    Request.post(url.ADD_STATIC_OTP, {
      email_or_mobile: contactValue,
      otp: value,
    })
      .then((res) => {
        toast.success(res.data?.msg || "Static OTP added successfully");
        type === "email" ? setEmailOtpValue("") : setMobileOtpValue("");
        getProfileListDetail();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Failed to add static OTP");
      })
      .finally(() => setStaticOtpLoading(false));
  };
  const handleDeleteStaticOtp = (item: any) => {
    setStaticOtpLoading(true);
    Request.post(url.DELETE_STATIC_OTP, {
      otpId: item?._id,        
    })
      .then((res) => {
        toast.success(res.data?.msg || "Static OTP deleted successfully");
        getProfileListDetail();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Failed to delete static OTP");
      })
      .finally(() => setStaticOtpLoading(false));
  };      

  const getProfileListDetail = () => {
    setLoading(true);
    const reqObj = {
      userId: params.id,
    };
    Request.post(url.GET_PROFILE_LIST_DETAILS, reqObj)
      .then((res) => {
        const data = res.data;
        setStreak({
          count: data?.data?.noOfStreak ?? 0,
          lastStreakDate: data?.data?.lastStreakDate ?? "",
        });
        setMobileGrid(data?.data?.mobileGrid ?? 0);
        settabGrid(data?.data?.tabGrid ?? 0);
        setSearchBar(data?.data?.isSearchBar ?? false);
        setNoOfDeviceLimit(data?.data?.noOfDeviceLimit ?? 0);
        setStaticOtps(data?.data?.staticOtps ?? []);
        const loadedForm: EditForm = {
          firstname: data?.data?.firstname ?? "",
          lastname: data?.data?.lastname ?? "",
          email: data?.data?.email ?? "",
          mobile: data?.data?.mobile ?? "",
          cityId: data?.data?.cityId ?? "",
          noOfDeviceLimit: data?.data?.noOfDeviceLimit ?? "",
          defaultScreen: data?.data?.defaultScreen ?? "",
          mobileGrid: data?.data?.mobileGrid ?? 0,
          isSearchBar: data?.data?.isSearchBar ?? false,
          vacationMode: data?.data?.vacationMode ?? false,
        };
        const cityId = data?.data?.cityId;
        const cityName = data?.data?.address;

        setSelectedCityOption(
          cityId
            ? {
                value: cityId,
                label: cityName || "",
              }
            : null
        );
        setEditForm(loadedForm);
        setOriginalForm(loadedForm);

        dispatch(
          setSelectedProfileDetails({
            id: data?.data?.id ?? null,
            firstname: data?.data?.firstname ?? null,
            lastname: data?.data?.lastname ?? null,
            email: data?.data?.email ?? null,
            mobile: data?.data?.mobile ?? null,
          })
        );
        setProfileDetails([
          {
            name: "User Id",
            data: `#${data?.data?.id}`,
          },
          {
            name: "Name",
            data: `${data?.data?.firstname} ${data?.data?.lastname}`,
          },
          {
            name: "Email",
            data: data?.data?.email ? data?.data?.email : "--",
          },
          {
            name: "Mobile",
            data: data?.data?.mobile ? data?.data?.mobile : "--",
          },
          {
            name: "Address",
            data: data?.data?.address ? data?.data?.address : "--",
          },
          {
            name: "Created At",
            data: data?.data?.createdAt
              ? convertProfileLocalDate(data?.data?.createdAt)
              : "--",
          },
          {
            name: "Last login",
            data: data?.data?.lastLogin
              ? convertProfileLocalDate(data?.data?.lastLogin)
              : "--",
          },
          {
            name: "Last Action",
            data: data?.data?.lastAction
              ? convertProfileLocalDate(data?.data?.lastAction)
              : "--",
          },
          {
            name: "Last Online Time",
            data: data?.data?.lastOnlineTime
              ? convertProfileLocalDate(data?.data?.lastOnlineTime)
              : "--",
          },
          {
            name: "Last Offline Time",
            data: data?.data?.lastOfflineTime
              ? convertProfileLocalDate(data?.data?.lastOfflineTime)
              : "--",
          },
        ]);
        setDeviceDetails([
          {
            name: "Chips",
            key: "chips",
            online: data.onlineChips,
            offline: data.offlineChips,
            max: data.maxSignalStrength,
            min: data.minSignalStrength,
            total:
              (Number(data.onlineChips) || 0) +
              (Number(data.offlineChips) || 0),
          },
          {
            name: "Blasters",
            key: "blaster",
            online: data.onlineBlasters,
            offline: data.offlineBlasters,
            max: data.maxSignalBlaster,
            min: data.minSignalBlaster,
            total:
              (Number(data.onlineBlasters) || 0) +
              (Number(data.offlineBlasters) || 0),
          },
          {
            name: "Curtains",
            key: "curtain",
            online: data.onlineAirCurtains,
            offline: data.offlineAirCurtains,
            max: data.maxSignalAirCurtain,
            min: data.minSignalAirCurtain,
            total:
              (Number(data.onlineAirCurtains) || 0) +
              (Number(data.offlineAirCurtains) || 0),
          },
          {
            name: "Drivers",
            key: "gateway",
            online: data.onlineAirDrivers,
            offline: data.offlineAirDrivers,
            max: data.maxSignalAirDriver,
            min: data.minSignalAirDriver,
            total:
              (Number(data.onlineAirDrivers) || 0) +
              (Number(data.offlineAirDrivers) || 0),
          },
          {
            name: "Air Gateway",
            key: "gateway",
            online: data.onlineAirGateway,
            offline: data.offlineAirGateway,
            max: data.maxSignalAirGateway ?? 0,
            min: data.minSignalAirGateway ?? 0,
            total:
              (Number(data.onlineAirGateway) || 0) +
              (Number(data.offlineAirGateway) || 0),
          },
        ]);

        setPremiseList(data?.premises);
        if (!selectedPremise) {
          setSelectedPremise(data?.premises[0]);
        } else {
          if (
            data?.premises?.filter(
              (premise: any) => premise?.id === selectedPremise?.id
            )
          ) {
            const premise = data?.premises?.filter(
              (premise: any) => premise?.id === selectedPremise?.id
            );
            setSelectedPremise(premise[0]);
          }
        }
        const rooms = [...(data?.rooms || [])]; // Ensure data?.rooms is an array or initialize as an empty array if undefined
        setRoomList(rooms);
        setsharedList(data?.sharedUserList || []);
        setParentList(data?.parentUserList || []);
        setIsVacationMode(data?.data?.vacationMode);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getProfileListDetail();
  }, []);

  const handlePremises = (e: any) => {
    const selectedPremise = premiseList.find(
      (item: any) => item.id === e.target.value
    );
    setSelectedPremise(selectedPremise);
  };

  useEffect(() => {
    if (!selectedPremise?.id) return;
    dispatch(
      selectedPremiseRoomsList(
        roomList.filter((id) => id.premiseId === selectedPremise?.id)
      )
    );

    const rooms = roomList;
    const filteredRooms = rooms.filter((rooms) => rooms.name !== "No Room");
    filteredRooms.unshift({
      name: "No Room",
      id: "noroom",
      premiseId: selectedPremise?.id,
    });
    dispatch(
      selectedPremiseRooms(
        filteredRooms
          .filter((id) => id.premiseId === selectedPremise?.id)
          .map((item, index) => {
            return { ...item, isChecked: true };
          }),
      ),
    );
    dispatch(
      selectedPremiseRoomsNew(
        filteredRooms
          .filter((id) => id.premiseId === selectedPremise?.id)
          .map((item, index) => {
            return { ...item, isChecked: true };
          }),
      ),
    );
    setSelectedTab("chips");
  }, [selectedPremise?.id]);

  const handleRoomChecked = (checkedItem: any) => {
    dispatch(
      selectedPremiseRooms(
        selectedRooms.map((item: any, index: number) => {
          if (item.id === checkedItem.id) {
            return { ...item, isChecked: !item.isChecked };
          } else {
            return { ...item };
          }
        })
      )
    );
  };
  const handleRoomAllChecked = (bool: boolean) => {
    dispatch(
      selectedPremiseRooms(
        selectedRooms.map((item: any, index: number) => {
          return { ...item, isChecked: bool };
        })
      )
    );
  };

  const toggleProModal = () => {
    setOpenProModal(!isOpenProModal);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <PendingTicker actions={pendingActions}/>
        <div style={{ margin: 0 }}>
          <Breadcrumb
            title="Users"
            breadcrumbItem={"Profile List"}
            state={{ isReload: true }}
            titleClick={"/users"}
          />
        </div>
        <ToastContainer />

        <Card
          className="shadow-sm"
          style={{
            borderRadius: "8px",
            background: "#fff",
          }}
        >
          <CardBody className="p-0">
            <Row className="g-2">
              <Col xs={12} lg={6}>
                <div
                  className="h-100"
                  style={{
                    borderRadius: "8px",
                    background: "#fff",
                  }}
                >
                  {/* Header */}
                  <div
                    className="d-flex align-items-center justify-content-between px-3 py-2"
                    style={{
                      minHeight: "58px",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div>
                        <h5
                          className="mb-0 fw-bold"
                          style={{
                            color: "#111827",
                            fontSize: "18px",
                            lineHeight: 1.2,
                          }}
                        >
                          General Information
                          <i
                            className="bx bx-edit-alt text-primary ms-2"
                            style={{
                              cursor: "pointer",
                              fontSize: "17px",
                            }}
                            onClick={toggleEditModal}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Update Profile Detail"
                          />
                        </h5>
                      </div>

                      {!loading && (
                        <div className="d-flex align-items-center ms-2">
                          {isVacationMode ? (
                            <span
                              className="badge fw-semibold px-2 py-1"
                              style={{
                                background: "#e8f8ef",
                                color: "#20a464",
                                borderRadius: "6px",
                                fontSize: "11px",
                              }}
                            >
                              Vacation Mode: ON
                            </span>
                          ) : (
                            <span
                              className="badge fw-semibold px-2 py-1"
                              style={{
                                background: "#fff0f0",
                                color: "#ff5b5b",
                                borderRadius: "6px",
                                fontSize: "11px",
                              }}
                            >
                              Vacation Mode: OFF
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {!loading && (
                      <div className="ms-2">
                        <UserSettingModal
                          mobileGrid={mobileGrid}
                          tabGrid={tabGrid}
                          isSearchBar={isSearchBar}
                          noOfDeviceLimit={noOfDeviceLimit}
                          userId={params.id}
                        />
                      </div>
                    )}
                  </div>

                  {/* Profile Details */}
                  <div className="px-3 ">
                    <Row>
                      {profileDetails?.length > 0 ? (
                        <>
                          <Col xs={12} md={6}>
                            {profileDetails
                              .slice(0, 5)
                              .map((item: any, index: number) => (
                                <p
                                  key={index}
                                  style={{ color: "#858D9D", fontSize: 14 }}
                                  className="my-2"
                                >
                                  {item?.name}:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#000",
                                    }}
                                  >
                                    {item?.data}
                                  </span>
                                </p>
                              ))}
                          </Col>
                          <Col xs={12} md={6}>
                            {profileDetails
                              .slice(5, 10)
                              .map((item: any, index: number) => (
                                <p
                                  key={index}
                                  style={{ color: "#858D9D", fontSize: 14 }}
                                  className="my-2"
                                >
                                  {item?.name}:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#000",
                                    }}
                                  >
                                    {item?.data}
                                  </span>
                                </p>
                              ))}
                          </Col>
                        </>
                      ) : (
                        <Col
                          xs={12}
                          md={12}
                          className="d-flex justify-content-center align-items-center"
                          style={{ minHeight: "155px" }}
                        >
                          <Spinner color="dark" />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </Col>

              <Col xs={12} lg={6}>
                <div
                  className="h-100"
                  style={{
                    borderRadius: "8px",
                    background: "#fff",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between px-3 py-2"
                    style={{
                      minHeight: "58px",
                    }}
                  >
                    <h5
                      className="mb-0 fw-bold"
                      style={{
                        color: "#111827",
                        fontSize: "18px",
                        lineHeight: 1.2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Device Overview
                    </h5>

                    {!loading && (
                      <div className="d-flex align-items-center gap-2">
                        <SharedUsersList
                          sharedList={sharedList}
                          parentList={parentList}
                          grantorUserId={params.id as string}
                          premiseId={selectedPremise?.id}
                          onShareSuccess={getProfileListDetail}
                        />

                        <div className="d-flex align-items-center">
                          <AccountSummary userId={params.id}  onPendingActionsChange={setAccountPendingActions}/>

                          <div className="ms-1">
                            <div
                              className="mb-0"
                              style={{
                                fontSize: "9px",
                                color: "#858D9D",
                                lineHeight: "12px",
                              }}
                            >
                              Daily Streak
                            </div>

                            <h5
                              id="streak-btn"
                              className="mb-0 d-flex align-items-center fw-bold"
                              style={{
                                color: "#111827",
                                fontSize: "14px",
                                lineHeight: "18px",
                              }}
                            >
                              {streak.count}
                              <box-icon
                                type="solid"
                                name="hot"
                                color="orange"
                                size="16px"
                              />
                            </h5>

                            <p
                              className="mb-0 text-nowrap"
                              style={{
                                fontSize: "8px",
                                color: "#858D9D",
                                lineHeight: "11px",
                              }}
                            >
                              {streak.lastStreakDate}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="px-3 py-2">
                    <Row>
                      {deviceDetails?.length > 0 ? (
                        <>
                          <table
                            className="table table-sm table-bordered text-center"
                            style={{ fontSize: "12px" }}
                          >
                            <thead className="table-light">
                              <tr>
                                <th className="p-1">Device</th>
                                <th className="p-1">total</th>
                                <th className="p-1">Online</th>
                                <th className="p-1">Offline</th>
                                <th className="p-1">Max Signal</th>
                                <th className="p-1">Min Signal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {deviceDetails.map((item, index) => (
                                <tr key={index}>
                                  <td
                                    className="p-1 fw-bold"
                                    onClick={() => handleTabChange(item.key)}
                                    style={{
                                      cursor: "pointer",
                                      transition: "0.2s",
                                    }}
                                    onMouseEnter={(e: any) => {
                                      e.target.style.color = "#0d6efd";
                                      e.target.style.textDecoration =
                                        "underline";
                                    }}
                                    onMouseLeave={(e: any) => {
                                      e.target.style.color = "";
                                      e.target.style.textDecoration = "none";
                                    }}
                                  >
                                    {item.name}
                                  </td>

                                  <td className="p-1 fw-bold">{item.total}</td>

                                  <td className="p-1 text-success fw-bold">
                                    {item.online}
                                  </td>

                                  <td className="p-1 text-danger fw-bold">
                                    {item.offline}
                                  </td>
                                  <td className="p-1">{item.max}</td>
                                  <td className="p-1">{item.min}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <Col
                          xs={12}
                          md={12}
                          className="d-flex justify-content-center align-items-center"
                          style={{ minHeight: "155px" }}
                        >
                          <Spinner color="dark" />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row style={{ marginBottom: 20 }}>
          <Col lg={3}>
            <div className="">
              <label
                htmlFor="client_type"
                className="form-label d-flex align-items-center gap-2"
              >
                Premises ({premiseList?.length ?? 0})
                {selectedPremise?.isParent && (
                  <span className="badge bg-primary">Shared</span>
                )}
              </label>
              <select className="form-select" onChange={handlePremises}>
                {premiseList?.map((item: any, index: number) => {
                  return (
                    <option
                      value={item?.id}
                      key={index}
                      style={{
                        backgroundColor: item?.isParent ? "#e3f2fd" : "#ffffff",
                        color: item?.isParent ? "#1565c0" : "#000000",
                        fontWeight: item?.isParent ? "bold" : "normal",
                      }}
                    >
                      {item.name} {item?.isParent ? "(Shared)" : ""}
                    </option>
                  );
                })}
              </select>
              {selectedPremise?.isPro ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 5,
                    alignItems: "center",
                  }}
                >
                  <span className="font-size-11 badge-soft-success badge bg-secondary">
                    This premise is Pro.
                  </span>
                  <span
                    onClick={() => setOpenProModal(true)}
                    className="btn btn-sm btn-dark"
                  >
                    Remove Pro
                  </span>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 5,
                    alignItems: "center",
                  }}
                >
                  <span className="font-size-11 badge-soft-danger badge bg-secondary">
                    This premise is not Pro.
                  </span>
                  <span
                    onClick={() => setOpenProModal(true)}
                    className="btn btn-sm btn-dark"
                  >
                    Mark as Pro
                  </span>
                </div>
              )}
            </div>
          </Col>
          <Col lg={9} className="d-flex align-items-center">
            <div
              style={{
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: "#ffffff",
                width: "100%",
              }}
            >
              <Row className="g-1">
                {selectedRooms.map((item: any, index: number) => (
                  <Col
                    key={index}
                    lg={2}
                    md={3}
                    xs={6}
                    className="d-flex align-items-center"
                    style={{ fontSize: 14, cursor: "pointer" }}
                    onClick={() => handleRoomChecked(item)}
                  >
                    <input
                      type="checkbox"
                      style={{ marginRight: 10, accentColor: "#343A40" }}
                      checked={item.isChecked}
                      readOnly
                    />
                    {item.name}
                  </Col>
                ))}

                {/*Select All */}
                <Col
                  lg={2}
                  md={3}
                  xs={6}
                  className="d-flex align-items-center"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => handleRoomAllChecked(true)}
                >
                  <input
                    type="checkbox"
                    style={{ marginRight: 10, accentColor: "#343A40" }}
                    checked={selectedRooms.every((room: any) => room.isChecked)}
                    readOnly
                  />
                  Select All
                </Col>

                {/* Remove All */}
                <Col
                  lg={2}
                  md={3}
                  xs={6}
                  className="d-flex align-items-center"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => handleRoomAllChecked(false)}
                >
                  <input
                    type="checkbox"
                    style={{ marginRight: 10, accentColor: "#343A40" }}
                    checked={selectedRooms.every(
                      (room: any) => !room.isChecked,
                    )}
                    readOnly
                  />
                  Remove All
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {selectedPremise?.isParent && (
          <div
            className="alert alert-primary d-flex align-items-center justify-content-between w-100 mb-3"
            role="alert"
          >
            <div className="d-flex align-items-center justify-content-center gap-2 ">
              <strong>Shared Premise :</strong>
              <div
                className="text-primary-emphasis"
                style={{ fontSize: "0.8rem", lineHeight: "1.2" }}
              >
                {selectedPremise?.name}
              </div>
            </div>
          </div>
        )}

        <Row style={{ marginBottom: 20 }}>
          <Col>
            <Nav
              className="rounded-pills"
              style={{
                backgroundColor: "#F1F1F1",
                width: "fit-content",
                borderRadius: 10,
              }}
            >
              {tabs.map(({ key, label }) => (
                <NavItem key={key}>
                  <NavLink
                    onClick={() => handleTabChange(key)}
                    className={classNames({ active: selectedTab === key })}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedTab === key ? "#343a40" : "#F1F1F1",
                      fontWeight: selectedTab === key ? 500 : 300,
                      borderRadius: 10,
                      fontSize: 16,
                      color: selectedTab === key ? "#ffffff" : "#000000",
                    }}
                  >
                    {label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Col>
        </Row>

        {/* Dynamically render the selected tab's component */}
        {/* {tabs.map(({ key, component: Component }) =>
          selectedTab === key ? (
            <Component
              key={key}
              userId={params.id}
              selectedPremise={selectedPremise}
              
            />
          ) : null,
        )} */}
        {tabs.map(({ key, component: Component }) =>
          selectedTab === key ? (
            <Component
              key={key}
              userId={params.id}
              selectedPremise={selectedPremise}
         {...(key === "chips"
  ? {
      onTouchCodeAlertsChange: (actions: PendingAction[]) =>
        setTouchCodeActions(actions),
    }
  : {})}
            />
          ) : null,
        )}

        <Modal
          isOpen={isOpenProModal}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          // tabIndex="-1"
          toggle={toggleProModal}
        >
          <div className="modal-content">
            <ModalHeader style={{ justifyContent: "center" }}>
              {selectedPremise?.isPro ? "Remove Pro" : "Mark As Pro"}
            </ModalHeader>

            <ModalBody>
              <Label>{`Are you sure you want to ${
                selectedPremise?.isPro
                  ? "remove Pro from this premise?"
                  : "mark this premise as Pro?"
              }`}</Label>
            </ModalBody>
            <ModalFooter style={{ justifyContent: "right" }}>
              <button
                className="btn btn-outline-secondary"
                data-bs-target="#secondmodal"
                onClick={() => {
                  toggleProModal();
                  // tog_toggleModal1();
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-dark"
                data-bs-target="#secondmodal"
                onClick={() => {
                  changeProPremise();
                }}
                disabled={loading && loading}
              >
                {selectedPremise?.isPro ? "Remove Pro" : "Mark As Pro"}
              </button>
            </ModalFooter>
          </div>
        </Modal>

        {/* Edit Profile Details modal  */}       
        <Modal
          isOpen={isEditModalOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          toggle={toggleEditModal}
          size="lg"
          scrollable
        >
          <div className="modal-content border-0">
            <ModalHeader toggle={toggleEditModal} className="border-bottom pb-3">
              <div>
                <h5 className="mb-1 fw-semibold">Edit Profile Details</h5>
                <p className="mb-0 text-muted small">
                  Update personal preferences and settings
                </p>
              </div>
            </ModalHeader>

            <ModalBody className="px-4 py-4">
              <div className="mb-4">

                <div className="row g-3">
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      First Name
                    </Label>
                    <Input
                      type="text"
                      name="firstname"
                      value={editForm.firstname}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      Last Name
                    </Label>
                    <Input
                      type="text"
                      name="lastname"
                      value={editForm.lastname}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      Email
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      value={editForm.email}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      Mobile
                    </Label>
                    <Input
                      type="text"
                      name="mobile"
                      value={editForm.mobile}
                      onChange={handleEditChange}
                    />
                  </div>
                </div>
              </div>

              {/* static otp */}
              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <h6 className="mb-0 fw-semibold">Static OTP</h6>
                
                </div>

                <div className="row g-3">
                  {/* Email OTP */}
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      Email OTP
                    </Label>
                    {(() => {
                      const emailContact = editForm.email?.trim();
                      const savedEmailOtp = staticOtps.find(
                        (item: any) => item?.email === emailContact,
                      );

                      return (
                        <>
                          <div className="d-flex align-items-center gap-2">
                            <Input
                              type="text"
                              value={emailOtpValue}
                              onChange={(e) => setEmailOtpValue(e.target.value)}
                              placeholder="Enter email OTP"
                              maxLength={4}
                              disabled={!!savedEmailOtp}
                            />
                            <button
                              type="button"
                              className="btn btn-dark flex-shrink-0"
                              onClick={() => handleAddStaticOtp("email")}
                              disabled={staticOtpLoading || !!savedEmailOtp || !emailContact || !emailOtpValue.trim()}
                            >
                              {staticOtpLoading ? <Spinner size="sm" /> : "Add"}
                            </button>
                          </div>
                          {savedEmailOtp ? (
                            <div className="d-flex align-items-center justify-content-between gap-2 mt-2 px-2 py-1 rounded bg-light border">
                              <small className="text-muted text-break">
                                OTP:{" "}
                                <strong className="text-dark">
                                  {savedEmailOtp.otp}
                                </strong>
                              </small>
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center p-0 border-0 bg-transparent shadow-none rounded-circle text-danger"
                                style={{
                                  width: "32px",
                                  height: "25px",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                                disabled={staticOtpLoading}
                                onClick={() =>
                                  handleDeleteStaticOtp(savedEmailOtp)
                                }
                                title="Delete email OTP"
                              >
                                <i className="bx bx-trash" />
                              </Button>
                            </div>
                          ) : (
                            <small className="text-muted d-block mt-2">
                              {emailContact
                                ? "No static OTP added for email"
                                : "Add an email address to configure OTP"}
                            </small>
                          )}
                        </>
                      );
                    })()}
                  </div>

                  {/* Mobile OTP */}
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary">
                      Mobile OTP
                    </Label>
                    {(() => {
                      const mobileContact = editForm.mobile?.trim();
                      const savedMobileOtp = staticOtps.find(
                        (item: any) => item?.mobile === mobileContact,
                      );

                      return (
                        <>
                          <div className="d-flex align-items-center gap-2">
                            <Input
                              type="text"
                              value={mobileOtpValue}
                              onChange={(e) =>
                                setMobileOtpValue(e.target.value)
                              }
                              placeholder="Enter mobile OTP"
                              disabled={!!savedMobileOtp}
                              maxLength={4}
                            />
                            <button
                              type="button"
                              className="btn btn-dark flex-shrink-0"
                              onClick={() => handleAddStaticOtp("mobile")}
                              disabled={
                                staticOtpLoading ||
                                !!savedMobileOtp ||
                                !mobileContact ||
                                !mobileOtpValue.trim()
                              }
                            >
                              {staticOtpLoading ? <Spinner size="sm" /> : "Add"}
                            </button>
                          </div>
                          {savedMobileOtp ? (
                            <div className="d-flex align-items-center justify-content-between gap-2 mt-2 px-2 py-1 rounded bg-light border">
                              <small className="text-muted text-break">
                                OTP:{" "}
                                <strong className="text-dark">
                                  {savedMobileOtp.otp}
                                </strong>
                              </small>
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center p-0 border-0 bg-transparent shadow-none rounded-circle text-danger"
                                style={{
                                  width: "32px",
                                  height: "25px",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                                disabled={staticOtpLoading}
                                onClick={() =>
                                  handleDeleteStaticOtp(savedMobileOtp)
                                }
                                title="Delete mobile OTP"
                              >
                                <i className="bx bx-trash" />
                              </Button>
                            </div>
                          ) : (
                            <small className="text-muted d-block mt-2">
                              {mobileContact
                                ? "No static OTP added for mobile"
                                : "Add a mobile number to configure OTP"}
                            </small>
                          )}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary d-flex align-items-center">
                      No of Device Limit
                      <i
                        className="bx bx-info-circle cursor-pointer fs-5 ps-2 text-muted "
                        data-tooltip-id="no-of-device-limit"
                      />
                      <Tooltip
                        id="no-of-device-limit"
                        place="right"
                        content="A maximum of 5 devices can be added. To add more devices, please contact the admin"
                        style={{ width: "300px", fontSize: "11px", zIndex: 1 }}
                      />
                    </Label>
                    <Input
                      type="number"
                      name="noOfDeviceLimit"
                      min={0}
                      value={editForm.noOfDeviceLimit}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^[0-5]$/.test(value)) {
                          handleEditChange(e);
                        }
                      }}
                      className=""
                    />
                  </div>

                  <div className="col-md-6">
                    <Label className="form-label small fw-medium text-secondary d-flex align-items-center mb-2">
                      Default Screen
                      <i
                        className="bx bx-info-circle cursor-pointer fs-5 ps-2 text-muted"
                        data-tooltip-id="defualt-screen"
                      />
                      <Tooltip
                        id="defualt-screen"
                        place="right"
                        content="Choose which screen opens automatically when you launch the app"
                        style={{ width: "300px", fontSize: "11px", zIndex: 1 }}
                      />
                    </Label>
                    <Select
                      placeholder="Select default screen"
                      value={
                        DEFAULT_SCREEN_OPTIONS.find(
                          (opt) => opt.value === editForm.defaultScreen,
                        ) || null
                      }
                      options={DEFAULT_SCREEN_OPTIONS}
                      onChange={handleDefaultScreenChange}
                      isSearchable={false}
                      styles={citySelectStyles}
                      menuPortalTarget={document.body}
                    />
                  </div>

                  <div className="col-12">
                    <Label className="form-label small fw-medium text-secondary">
                      City
                    </Label>
                    <Select
                      placeholder="Search city..."
                      value={selectedCityOption}
                      options={cityOptions}
                      onChange={handleCityChange}
                      onInputChange={(inputValue) => {
                        citySearchApiCall(inputValue, setCityOptions);
                        return inputValue;
                      }}
                      isSearchable
                      isClearable
                      styles={citySelectStyles}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>
              </div>

              <div>
                <div className="mb-3">
                  <Label className="form-label small fw-medium text-secondary d-block">
                    Mobile Grid
                  </Label>
                  <div className="d-flex gap-2">
                    {MOBILE_GRID_OPTIONS.map((val) => (
                      <button
                        type="button"
                        key={val}
                        className={classNames("btn btn-sm px-4", {
                          "btn-dark": editForm.mobileGrid === val,
                          "btn-outline-secondary": editForm.mobileGrid !== val,
                        })}
                        onClick={() => handleMobileGridChange(val)}
                      >
                        {val}
                      </button>
                    ))}
                  </div>
                </div>

                <div className=" rounded-3 overflow-hidden">
                  <div className="d-flex align-items-center py-2 ">
                    <Label className="mb-0 fw-medium">Vacation Mode</Label>
                    <div className="form-check form-switch mb-0">
                      <Input
                        type="checkbox"
                        name="vacationMode"
                        role="switch"
                        checked={editForm.vacationMode}
                        onChange={handleEditChange}
                        className="form-check-input m-0"
                        style={{ width: 40, height: 20, cursor: "pointer" }}
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center py-2">
                    <Label className="mb-0 fw-medium d-flex align-items-center">
                      Is Searchbar
                      <i
                        className="bx bx-info-circle cursor-pointer fs-5 ps-2 text-muted"
                        data-tooltip-id="searchbar-tooltip"
                      />
                      <Tooltip
                        id="searchbar-tooltip"
                        place="right"
                        content="Adds a search bar on the Home screen for finding switches faster. Useful when you have many devices."
                        style={{
                          width: "300px",
                          fontWeight: "bold",
                          zIndex: 1,
                        }}
                      />
                    </Label>
                    <div className="form-check form-switch mb-0">
                      <Input
                        type="checkbox"
                        name="isSearchBar"
                        role="switch"
                        checked={editForm.isSearchBar}
                        onChange={handleEditChange}
                        className="form-check-input m-0"
                        style={{ width: 40, height: 20, cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>

            <ModalFooter
              className="border-top px-4 py-3"
              style={{ justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary px-4"
                onClick={toggleEditModal}
              >
                Cancel
              </button>
              <button
                className="btn btn-dark px-4"
                onClick={handleUpdateProfile}
                disabled={editLoading}
              >
                {editLoading ? "Saving..." : "Save Changes"}
              </button>
            </ModalFooter>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default ProfileList;